/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Layout, Card, Table, Tag, Select, Row, Col, Spin } from "antd";
import dayjs from "dayjs";

import { getAPI, postAPI } from "../../../utils/common";
import { STOCK_LEDGER, ALL_LAUNDRY_ITEM } from "../../../constants/api";

const { Content } = Layout;
const { Option } = Select;

function StockLedger() {
  const [items, setItems] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [itemId, setItemId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load Items
  useEffect(() => {
    getAPI(
      ALL_LAUNDRY_ITEM,
      (res) => {
        if (res.status) setItems(res.data);
      }
    );
  }, []);

  // Load Ledger
  useEffect(() => {
    fetchLedger();
  }, [itemId]);

  const fetchLedger = () => {
    setLoading(true);

    const params = itemId ? { item_id: itemId } : {};

    postAPI(
      STOCK_LEDGER,
      params,
      (res) => {
        if (res.status) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            Date: dayjs(row.created_at).format("DD MMM YYYY"),
            Item: row.item?.name,
            Type: row.type,
            Qty: row.qty,
            Remark: row.remark,
          }));
          setLedger(formatted);
        } else {
          setLedger([]);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  const typeTag = (type) => {
    switch (type) {
      case "in":
        return <Tag color="green">IN</Tag>;
      case "out":
        return <Tag color="blue">OUT</Tag>;
      case "damage":
        return <Tag color="red">DAMAGE</Tag>;
      case "missing":
        return <Tag color="volcano">MISSING</Tag>;
      case "opening":
        return <Tag color="purple">OPENING</Tag>;
      default:
        return <Tag>{type}</Tag>;
    }
  };

  const columns = [
    { title: "Date", dataIndex: "Date", width: 150 },
    { title: "Item", dataIndex: "Item", width: 250 },
    {
      title: "Type",
      dataIndex: "Type",
      width: 120,
      render: (type) => typeTag(type),
    },
    { title: "Qty", dataIndex: "Qty", width: 100 },
    { title: "Remark", dataIndex: "Remark" },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Stock Ledger"
          extra={
            <Row gutter={10}>
              <Col>
                <Select
                  allowClear
                  placeholder="Filter by Item"
                  style={{ width: 250 }}
                  onChange={(val) => setItemId(val)}
                >
                  {items.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          }
        >
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={ledger}
              pagination={{ pageSize: 15 }}
              scroll={{ x: 900 }}
            />
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default StockLedger;
